import { IonButton, IonHeader, IonContent, IonToolbar, IonButtons, IonText, IonIcon, IonItem, IonLabel, IonThumbnail, IonGrid, IonRow, IonCol, IonToast, IonTitle, IonCard, IonCardContent, IonCardHeader, IonCardSubtitle } from "@ionic/react";
import { useState } from "react";
import { useTranslation } from 'react-i18next';
import './QrCodePageStellarToken.css';
import { QRCode } from 'react-qrcode-logo';
import { arrowBackOutline, copyOutline, informationCircle, shareOutline } from "ionicons/icons";
import { useAppSelector } from '../../services/redux/hook';
import { Clipboard } from '@capacitor/clipboard';
import useDarkMode from "../../hooks/useDarkMode";
import { Share } from '@capacitor/share';

type MyModalProps = {
    closeAction?: () => void;
}

export default function QrCodePageStellarToken({ closeAction }: MyModalProps) {

    const { darkMode } = useDarkMode();
    const nav = document.querySelector("ion-nav");
    const { t, i18n } = useTranslation();
    const selectedAsset = useAppSelector((state) => state.selectedAsset);
    const walletInfo = useAppSelector((state) => state.walletInfo);
    const [showToast, setShowToast] = useState(false);

    const shortenAccountId = (fullStr: string, length?: number) => {

        let strLen = 25;
        if (length) {
            strLen = length
        }
        const separator = '...';

        if (fullStr.length <= strLen) return fullStr;

        const sepLen = separator.length;
        const charsToShow = strLen - sepLen;
        const frontChars = Math.ceil(charsToShow / 2);
        const backChars = Math.floor(charsToShow / 2);

        return fullStr.substr(0, frontChars) +
            separator +
            fullStr.substr(fullStr.length - backChars);
    }

    const writeAddressToClipboard = async () => {

        await Clipboard.write({
            string: walletInfo?.account_key as string
        });

        setShowToast(true)

    };

    const shareAccount = async () => {

        const text = `${t('receive.page.SHARE.TEXT-1')} ${selectedAsset.code} ${t('receive.page.SHARE.TEXT-2')}: ${walletInfo?.account_key as string}`;

        try {

            await Share.share({
                text: text,
            });

        } catch (error) {

        }
    }

    return (

        <>

            <IonHeader className="ion-no-border" >

                <IonToolbar >
                    <IonButtons slot="start" onClick={() => { nav?.pop() }}>
                        <IonButton color={'primary'} >
                            <IonIcon slot="icon-only" icon={arrowBackOutline} />
                        </IonButton>
                    </IonButtons>
                    <IonTitle className="ion-text-center"> {selectedAsset.name} </IonTitle>
                    <IonItem lines="none" slot="primary" className="accountDetailsPageHeaderItem"

                    >
                        <IonThumbnail className="accountsPage_Thumbnail_Flag" slot="start">
                            <img src={selectedAsset.icon} />
                        </IonThumbnail>
                    </IonItem>
                </IonToolbar>

            </IonHeader>

            <IonContent>

                <IonToast
                    isOpen={showToast}
                    onDidDismiss={() => setShowToast(false)}
                    cssClass="accountDetailsToast"
                    message={t('qrCodePageCopiedClipboardMessage') as string}
                    color="primary"

                    duration={600}
                    position="top"
                />

                <div className="qrCodePage_center">
                    <IonCard>
                        <IonCardContent>
                            <QRCode
                                value={walletInfo?.account_key || ''}
                                qrStyle='fluid'
                                bgColor="transparent"
                                fgColor={darkMode ? "#ffffff" : "#04394F"}
                            />
                            <IonText
                                className='qrCodePage_label' >
                                <h5> {shortenAccountId(walletInfo?.account_key || '', 20)}</h5>

                            </IonText>
                        </IonCardContent>
                    </IonCard>



                </div>

                <IonGrid style={{marginLeft:'15%',marginRight:'15%'}} >

                    <IonRow  >

                        <IonCol>
                            
                            <IonButton
                                className="ion-text-center"

                                size="large"
                                fill="clear"
                                color={'primary'}
                                onClick={() => { writeAddressToClipboard() }}>
                                <IonIcon color="primary" icon={copyOutline}></IonIcon>
                            </IonButton>

                            <br />
                            <IonLabel className="ion-text-center" >
                                {t('receive.page.BTN.COPY')}
                            </IonLabel>
                            
                        </IonCol>

                        <IonCol >

                            <IonButton

                                size="large"
                                fill="clear"
                                color={"primary"}
                                onClick={() => { shareAccount() }}>
                                <IonIcon color="primary" icon={shareOutline}></IonIcon>
                            </IonButton>
                            <br />

                            <IonLabel>{t('receive.page.BTN.SHARE')}</IonLabel>

                        </IonCol>
                    </IonRow>

                </IonGrid>

                <IonCard style={{ marginTop: '20%' }}>
                    <IonCardHeader className="ion-text-start">
                        <IonCardSubtitle>
                            {t('receive.page.IMPORTANT-INFO-LABEL')}
                        </IonCardSubtitle>
                    </IonCardHeader>
                    <IonCardContent>
                        <IonGrid>
                            <IonRow>
                                <IonCol>
                                    <IonItem lines="none">
                                        <IonIcon slot="start" icon={informationCircle} color="primary"></IonIcon>
                                        <p
                                            className='ion-text-justify' >
                                            {t('qrCodePageStellarToken.SUBHEADER_PART_1')} {selectedAsset.display_code} {t('qrCodePageStellarToken.SUBHEADER_PART_2')}
                                        </p>
                                    </IonItem>

                                </IonCol>
                            </IonRow>

                        </IonGrid>

                    </IonCardContent>
                </IonCard>

            </IonContent>

        </>

    )
}